module.exports = __webpack_public_path__ + "media/mypage/images/special/004-88c4f4f70bba7fcd0f8e77fbfe5e57ec.jpg";